export class EmployType {
  EmpType;
  CDesc;
  EDesc;
  Contract;
  ProbationMth;
  constructor() {
    this.EmpType = "";
    this.CDesc = "";
    this.EDesc = "";
    this.Contract = false;
    this.ProbationMth = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/EmployType.js